// extracted by mini-css-extract-plugin
export default {"buttons":"EditNotification_buttons__JgyEt","container":"EditNotification_container__-7b6u"};